
const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 85; i < 211; i++){
            listImg.push(`http://localhost:8081/media/${lang}/ccVirtualMeter/cc_virtualMeter_${i.toString().padStart(5, '0')}.jpg`)
        }
    } else {
        for(let i = 85; i < 211; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/ccVirtualMeter/cc_virtualMeter_${i.toString().padStart(5, '0')}.jpg`)
        }
    }
    return listImg;
}
export default images;
